// ReviewSummarySectionHeading.jsx

import React from "react";

const defaultClassName = "review-summary-sub-heading font-bold mt-16";

const ReviewSummarySectionHeading = ({ title, className }) => {
  return (
    <div i2c-grid="12@md" className={className || defaultClassName}>
      {title}
    </div>
  );
};

export default ReviewSummarySectionHeading;
